import { Component, OnInit, Inject } from '@angular/core';
import { Router } from '@angular/router';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Project } from 'src/app/entity/project';
import { UserService } from 'src/app/user/user.service';
import { SnackbarService } from 'src/app/snackbar/service/snackbar.service';
import { ProjectService } from '../project.service';
import { RoomService } from '../room.service';
import { RoomTableDto } from 'src/app/entity/roomTableDto';
import { MatTableDataSource } from '@angular/material/table';

@Component({
  selector: 'app-project-detail-view',
  templateUrl: './project-detail-view.component.html',
  styleUrls: ['./project-detail-view.component.scss'],
})
export class ProjectDetailViewComponent implements OnInit {
  isNew: boolean;
  entity: Project;

  rooms: MatTableDataSource<RoomTableDto> = new MatTableDataSource<RoomTableDto>();
  displayedColumns: string[] = [
    'roomName',
    'furnitureCount',
    'createdAt',
    'buttons',
  ];

  constructor(
    private router: Router,
    private projectService: ProjectService,
    public dialogRef: MatDialogRef<ProjectDetailViewComponent>,
    @Inject(MAT_DIALOG_DATA) public data: Project,
    private roomService: RoomService,
    private userService: UserService,
    private snackService: SnackbarService
  ) {}

  ngOnInit(): void {
    this.entity = this.data;
    this.isNew = this.entity.uuid !== undefined;

    if (!this.isNew) {
      this.roomService.getRoomsByProjectId(this.entity.id).subscribe(
        (res) => {
          this.rooms.data = res;
          this.snackService.open('Projekt geladen', 4, 'success');
        },
        (error) => {
          this.snackService.open(
            'Fehler beim Laden der Projekt Räume',
            4,
            'failed'
          );
        }
      );
    }
  }

  save() {
    if (this.isNew) {
      this.projectService.createProject(this.entity).subscribe(
        (res) => {
          this.snackService.open(
            'project.detail.snackbar.created',
            4,
            'success'
          );
          this.dialogRef.close();
        },
        (error) => {
          this.snackService.open(
            'shared.snackbar.saveSuccessful',
            4,
            'failed'
          );
        }
      );
    } else {
      this.projectService.updateProject(this.entity).subscribe(
        (res) => {
          this.snackService.open(
            'shared.snackbar.saveSuccessful',
            4,
            'success'
          );
          this.dialogRef.close();
        },
        (error) => {
          this.snackService.open('shared.snackbar.saveFailed', 4, 'failed');
        }
      );
    }
  }

  abort() {
    this.dialogRef.close();
  }

  showDetails(id: number) {
    this.dialogRef.close();

    this.router.navigate(['/project/detail/' + this.entity.id + '/' + id]);
  }
}
